import { render, staticRenderFns } from "./tuzhuangliangtingMb.vue?vue&type=template&id=28898a79&scoped=true&"
import script from "./tuzhuangliangtingMb.vue?vue&type=script&lang=js&"
export * from "./tuzhuangliangtingMb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28898a79",
  null
  
)

export default component.exports